<template>
  <div class="home">
    <ListProductSaisie :list="listProducts"/>
  </div>
</template>

<script>
// @ is an alias to /src
import ListProductSaisie from '@/components/Product/ListProductSaisie.vue';
// import services from 'services';

export default {
  components: {
    ListProductSaisie,
  },
  async mounted() {
    this.loading = true;
    // this.$store.dispatch('products/fetchProductsByStore');
    /* Here we use the service directly. You might prefer to use the store instead */
    // this.listProducts = await services.ProductService.getProductsByStore('5013');
    // this.listProducts = this.$store.getters['products/listProducts'];
    // console.log('this.listProducts');
    // console.log(this.listProducts);

    this.loading = false;
  },
  computed: {
    listProducts() {
      return [];
      // return this.$store.getters['products/listProducts'];
    },
  },
  data() {
    return {
      loading: false,
      // valConso: 0,
      // listProducts: [],
      // fakeCustomers: [],
    };
  },
  methods: { },
};
</script>
